// src/config.ts

interface AppConfig {
  API_URL: string;
  Contracts_URL: string;
  ContractsAPI_URL:string;
  ContractsArchive_URL: string;
}

let appConfig: AppConfig = {
  API_URL: 'https://webapi.icegems.com/api',
  Contracts_URL: "https://contracts.icegems.com",
  ContractsAPI_URL: "https://contractswebapi.icegems.com/api",
  ContractsArchive_URL: "https://icegems.com/ContractsArchive",
};

// load config variables from config.json
export async function loadConfig(): Promise<void> {
  try {
    const response = await fetch('/config.json');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data: AppConfig = await response.json(); // Type assertion for the parsed JSON
    appConfig = data;
    console.log("Configuration loaded:", appConfig);
  } catch (error) {
    console.error("Failed to load configuration:", error);
    // Fallback to a default URL if config.json can't be loaded or an error occurs
    appConfig = {
      API_URL: 'https://webapi.icegems.com/api',
      Contracts_URL: "https://contracts.icegems.com",
      ContractsAPI_URL: "https://contractswebapi.icegems.com/api",
      ContractsArchive_URL: "https://icegems.com/ContractsArchive",
    };
  }
}

export function getApiUrl(): string {
  return appConfig.API_URL;
}

export function getContractsUrl(): string {
  return appConfig.Contracts_URL;
}

export function getContractsAPIUrl(): string {
  return appConfig.ContractsAPI_URL;
}

export function getContractsArchiveUrl(): string {
  return appConfig.ContractsArchive_URL;
}

// You might also want a way to get the entire config object
export function getConfig(): AppConfig {
  return appConfig;
}